/*
このスクリプトにはjQueryライブラリが必要です。
ボディタグがTheme.Liquidで終了する直前にこのファイルを追加してください。
*/

$illJq(document).ready(function(){
  /// メイン検索入力
  $illJq('#pageheader .search-box input[type="text"]').bind('focusin focusout', function(e){
      $illJq(this).closest('.search-box').toggleClass('focus', e.type == 'focusin');
  });


  /// ライブ検索
  let searchTimeoutThrottle = 500;
  let searchTimeoutID = -1;
  let currReqObj = null;
  let resultsBox = $illJq('.results-box');

  $illJq('#pageheader .search-box input[type="text"]').bind('keyup change', function(){

    // 検索の文字列が２文字より多くて、前回のワードと違う時
    if($illJq(this).val().length > 2 && $illJq(this).val() != $illJq(this).data('oldval')) {
          //前の値をリセットします
          $illJq(this).data('oldval', $illJq(this).val());

          // 通信中のAjaxリクエストを中断
          if(currReqObj != null) currReqObj.abort();

          // 以前の検索を中断
          clearTimeout(searchTimeoutID);

          let searchForm = $illJq(this).closest('form');

          //検索キーワード
          let term = searchForm.find('input[name="q"]').val();

          //検索ページへのURL
          let linkURL = searchForm.attr('action') + '?type=product&q=' + term;

          searchTimeoutID = setTimeout(function(){
              currReqObj = $illJq.ajax({
                url: searchForm.attr('action'),
                data: {
                  type: 'product',
                  view: 'json',
                  q: term,
                },
                dataType: "json",
                success: function(data){
                  currReqObj = null;
                  if(data.results_total == 0) {
                      // 一致する商品がない時
                      resultsBox.html('<div class="note">'+ '一致する商品はありません。' +'</div>');
                  } else {
                    // 一致する商品がある時
                    resultsBox.empty();
                      $illJq.each(data.results, function(index, item){
                        let $illJqrow = $illJq('<a></a>').attr('href', item.url);
                        $illJqrow.append('<div class="d-title">'+item.title+'</div>');
                        resultsBox.append($illJqrow);
                      });

                      // 全ての結果を見るボタン
                      resultsBox.append('<a href="' + linkURL + '" class="note">対象の商品を見る</a>');
                  }
                }
              });
          }, searchTimeoutThrottle);

      } else if ($illJq(this).val().length <= 2) {
          //キーワードが２以下の時にサジェストの内容を削除する
          resultsBox.empty();
      }
  }).attr('autocomplete', 'off').data('oldval', '').bind('focusin', function(){
      // 再フォーカスされた時にサジェストを表示します
      resultsBox.fadeIn(200);
  }).bind('click', function(e){
      //クリックして、ボディが[イベント]をクリックしないようにします
      e.stopPropagation();
  });

  //サジェスト以外をクリックした時に、サジェストを非表示にする
  $illJq('body').bind('click', function(){
      resultsBox.fadeOut(200);
  });


  //検索するボタンをクリックした時の挙動
  //$illJq('.search-form, #search-form').on('submit', function(e){
  //  e.preventDefault();
  //  let term = $illJq(this).find('input[name="q"]').val();
  //  let linkURL = $illJq(this).attr('action') + '?type=product&q=' + term;
  //  window.location = linkURL;
  //});

});